<template>
  <div class="clipboard-button">
    <div class="success-copy" :class="{'active': success}">
      skopírované
    </div>
    <div class="text-cta pointer" @click="copyTextToClipboard()">
      kopírovať
    </div>
  </div>
</template>

<script>
export default {
  name: "ClipboardButton",
  props: {
    value: [String, Number],
  },
  methods: {
    async copyTextToClipboard () {
      await navigator.clipboard.writeText(this.value);
      this.success = true;
      setTimeout(() => {
        this.success = false;
      }, 1000);
    }
  },
  data: () => ({
    success: false,
  }),
}
</script>

<style lang="scss" scoped>

.clipboard-button {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.active {
  opacity: 1;
}
</style>
